import React from 'react';
import moment from 'moment';
import styled from 'styled-components';

import { Link } from 'react-router-dom';

const CarouselItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  line-height: 24px;
  text-decoration: none;

  a {
    text-decoration: none !important;
  }

  .carouselItemValue {
    white-space: nowrap;
    padding: 10px;
    background-color: #f9dfd6;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px !important;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
    border-radius: 8px;
    width: 50px;
    height: 50px;
    text-decoration: none;
    color: ${(props) => props.theme.colors['dark-two']};
  }

  .carouselItemContent {
    margin-left: 15px;
  }

  .carouselItemText {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    text-transform: uppercase;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    color: #2b3d54;

    text-decoration: none;
  }

  .carouselItemTitle {
    display: flex;
    flex-direction: row;
    text-transform: uppercase;
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 12px;
    color: #2b3d54;
    max-width: 140px;
    line-height: normal;
    text-decoration: none;
  }

  .carouselItemSub {
    font-size: 12px;
    line-height: 1.2;
    white-space: nowrap;
    color: ${(props) => props.theme.colors['dark-two']};
  }

  .carouselItemDate {
    color: ${(props) => props.theme.colors['terra-cotta']};
    font-family: Oswald;
    white-space: nowrap;
    font-size: 14px;
  }
`;

const LinkContainer = styled.div`
  a {
    text-decoration: none;
  }
`;

const networkToPage = {
  ON: '/distribution/restaurants',
  OFF: '/distribution/restaurants',
  WEB: '/distribution/online-sales/overview',
  PRI: '/distribution/primeur',
  AUC: '/distribution/auction'
};

const CarouselItem = ({ title, date, network_code }) => (
  <LinkContainer>
    <Link className="goToTravel" to={networkToPage[network_code]}>
      <CarouselItemContainer>
        <div className="carouselItemValue"></div>
        <div className="carouselItemContent">
          <p className="carouselItemTitle">
            {title} - {network_code}
          </p>
          <p className="carouselItemDate">
            {' '}
            {moment(date).format('DD/MM/YYYY')}
          </p>
        </div>
      </CarouselItemContainer>
    </Link>
  </LinkContainer>
);

export default CarouselItem;
